<template>
  <div>

    <!-- #region 割引プラン詳細 -->
    <CCard>
      <CCardHeader>
        <h3 class="card-title">割引プラン情報</h3>
      </CCardHeader>
      <CCardBody class="profile-home px-5">
        <div class="user-info-table-core mx-2">

          <CRow
            class="mb-3"
            v-if="discount.picture"
          >
            <CCol
              lg="2"
              class="m-0 p-0"
            >
              <CImg
                fluid
                :src="discount.picture"
                :align="center"
                class="rounded mx-auto my-3 d-block"
              />
            </CCol>
          </CRow>
          <CRow class="data-table">
            <CCol class="mr-3">
              <CRow>
                <CCol
                  class="t-title"
                  lg="5"
                >SKU</CCol>
                <CCol>{{ discount.sku }}</CCol>
              </CRow>
              <CRow>
                <CCol
                  class="t-title"
                  lg="5"
                >クーポン名</CCol>
                <CCol>{{ discount.name }}</CCol>
              </CRow>
              <CRow>
                <CCol
                  class="t-title"
                  lg="5"
                >クーポン説明</CCol>
                <CCol>{{ discount.description }}</CCol>
              </CRow>
            </CCol>
            <CCol class="mr-3">
              <CRow>
                <CCol
                  class="t-title"
                  lg="5"
                >発行済み件数</CCol>
                <CCol>{{ totalActivated }}</CCol>
              </CRow>
              <CRow>
                <CCol
                  class="t-title"
                  lg="5"
                >掲載開始日</CCol>
                <CCol>{{ discount.activatedSince | formatDate }}</CCol>
              </CRow>
              <CRow>
                <CCol
                  class="t-title"
                  lg="5"
                >掲載終了日</CCol>
                <CCol>{{ discount.activatedBefore | formatDate }}</CCol>
              </CRow>
            </CCol>
            <CCol>
              <CRow>
                <CCol
                  class="t-title"
                  lg="5"
                >ステータス</CCol>
                <CCol>{{ discount.status | statusName }}</CCol>
              </CRow>
              <CRow>
                <CCol
                  class="t-title"
                  lg="5"
                >利用開始日</CCol>
                <CCol>{{ discount.validateSince | formatDate }}</CCol>
              </CRow>
              <CRow>
                <CCol
                  class="t-title"
                  lg="5"
                >利用終了日</CCol>
                <CCol>{{ discount.validateUntil | formatDate }}</CCol>
              </CRow>

            </CCol>
          </CRow>
        </div>
      </CCardBody>
    </CCard>
    <!-- #endregion 割引プラン詳細 -->

    <!-- #region Alert -->
    <CAlert
      color="danger"
      class="mt-3 text-center"
      v-if="notFound"
    >
      割引プラン情報がありません。
    </CAlert>
    <!-- #endregion Alert -->

    <!-- #region Modal -->
    <!-- #endregion Modal -->

  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "DiscountInfo",

  props: {},

  data() {
    return {

      //#region Flag

      loading: false,

      //#endregion Flag

      //#region Response data

      discount: {}

      //#endregion Response data

    }
  },

  computed: {

    /** 割引プランID(UUID) */
    discountId() {
      return this.$route.params.uuid;
    },

    /** 発行済み件数 */
    totalActivated() {
      if(!this.discount || !this.discount.options) return;
      return this.discount.options.reduce((total, a) => total + a.activated, 0);
    },

  },

  methods: {

    //#region Event
    //#endregion Event


    //#region Request

    /** 割引プラン詳細を取得 */
    getDiscountDetail() {
      const discountId = this.discountId;
      let url = `/rest/discounts/${discountId}`;

      console.log(url);

      this.loading = true;

      axios
        .get(url, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          this.discount = resp.data;

          console.log("discount:" + JSON.stringify(this.discount));
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.notFound = true;

          this.loading = false;
        });
    },

    //#endregion Request


    //#region Method
    //#endregion Method

  },

  beforeMount() {
    this.getDiscountDetail();
  },

};
</script>
